import script from "./pairingProcess.vue?vue&type=script&setup=true&lang=js"
export * from "./pairingProcess.vue?vue&type=script&setup=true&lang=js"

import "./pairingProcess.vue?vue&type=style&index=0&id=05872a9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05872a9a"]])

export default __exports__